'use strict';import _jsx from"@babel/runtime/helpers/esm/jsx";import _defineProperty from"@babel/runtime/helpers/esm/defineProperty";var _class;import"core-js/modules/web.dom-collections.iterator.js";import React from'react';import{withRouter}from'react-router-dom';// import classNames from 'clsx';
// import { injectIntl, defineMessages } from 'react-intl';
// import Icon from 'soapbox/components/icon';
import SubNavigation from'soapbox/components/sub_navigation';// const messages = defineMessages({
//   show: { id: 'column_header.show_settings', defaultMessage: 'Show settings' },
//   hide: { id: 'column_header.hide_settings', defaultMessage: 'Hide settings' },
// });
let ColumnHeader=withRouter(_class=class ColumnHeader extends React.PureComponent{constructor(){super(...arguments);_defineProperty(this,"state",{collapsed:true,animating:false});_defineProperty(this,"historyBack",()=>{var _window$history;if(((_window$history=window.history)===null||_window$history===void 0?void 0:_window$history.length)===1){this.props.history.push('/');}else{this.props.history.goBack();}});_defineProperty(this,"handleToggleClick",e=>{e.stopPropagation();this.setState({collapsed:!this.state.collapsed,animating:true});});_defineProperty(this,"handleBackClick",()=>{this.historyBack();});_defineProperty(this,"handleTransitionEnd",()=>{this.setState({animating:false});});}render(){const{title}=this.props;return/*#__PURE__*/_jsx(SubNavigation,{message:title});}// render() {
//   const { title, icon, active, children, extraButton, intl: { formatMessage } } = this.props;
//   const { collapsed, animating } = this.state;
//
//   const wrapperClassName = classNames('column-header__wrapper', {
//     'active': active,
//   });
//
//   const buttonClassName = classNames('column-header', {
//     'active': active,
//   });
//
//   const collapsibleClassName = classNames('column-header__collapsible', {
//     'collapsed': collapsed,
//     'animating': animating,
//   });
//
//   const collapsibleButtonClassName = classNames('column-header__button', {
//     'active': !collapsed,
//   });
//
//   let extraContent, collapseButton;
//
//   if (children) {
//     extraContent = (
//       <div key='extra-content' className='column-header__collapsible__extra'>
//         {children}
//       </div>
//     );
//   }
//
//   const collapsedContent = [
//     extraContent,
//   ];
//
//   if (children) {
//     collapseButton = <button className={collapsibleButtonClassName} title={formatMessage(collapsed ? messages.show : messages.hide)} aria-label={formatMessage(collapsed ? messages.show : messages.hide)} aria-pressed={collapsed ? 'false' : 'true'} onClick={this.handleToggleClick}><Icon id='cog' /></button>;
//   }
//
//   const hasTitle = icon && title;
//
//   return (
//     <div className={wrapperClassName}>
//       <h1 className={buttonClassName}>
//         {hasTitle && (
//           <button>
//             <Icon id={icon} fixedWidth className='column-header__icon' />
//             {title}
//           </button>
//         )}
//
//         <div className='column-header__buttons'>
//           {extraButton}
//           {collapseButton}
//         </div>
//       </h1>
//
//       <div className={collapsibleClassName} tabIndex={collapsed ? -1 : null} onTransitionEnd={this.handleTransitionEnd}>
//         <div className='column-header__collapsible-inner'>
//           {(!collapsed || animating) && collapsedContent}
//         </div>
//       </div>
//     </div>
//   );
// }
})||_class;export{ColumnHeader as default};